export var REQUEST_DETAIL = 'REQUEST_DETAIL_MOVIE';
export var SUCCESS_DETAIL = 'SUCCESS_DETAIL_MOVIE';
export var FAILURE_DETAIL = 'FAILURE_DETAIL_MOVIE';